export default "__VITE_ASSET__BYUo3Sjl__"